<template>
  <div class="dato-abierto">
    <loading v-if="isLoading"></loading>
    <div class="data" v-if="!isLoading">
      <div class="breadcrumbs">
        <router-link :to="{name:'home'}">Datos Abiertos</router-link>
        / {{ topic }}
      </div>
      <div class="info">
        <h3>{{file.title}}</h3>
        <p class="area-topic"><strong>Tema:</strong> {{topic}}</p>
        <p v-if="file.tags"><strong>Palabras clave:</strong> {{file.tags}}</p>
        <p>
          <strong>Descripción</strong><br>
          {{file.description}}
        </p>
        <div class="container" style="padding-top: 10px">
          <div class="row">
            <div class="col-12 col-lg-6" style="padding:0 !important;">
              <p v-if="area" style="font-size:15px;">
                <strong>Área:</strong> <span style="text-transform: capitalize;">{{area}}</span> <span v-if="area_description"> - {{area_description}}</span>
              </p>
              <p v-if="file.last_update" style="font-size:15px;">
                <strong>Última actualización:</strong> <span style="text-transform: capitalize;">{{file.last_update}}</span>
              </p>
              <p v-if="file.responsable" style="font-size:15px;">
                <strong>Responsable de los datos:</strong> {{file.responsable}}
              </p>
              <p v-if="file.email" style="font-size:15px;">
                <strong>Correo electrónico:</strong> {{file.email}}
              </p>
            </div>
            <div class="col-12 col-lg-6" style="padding: 0 !important;">
              <p v-if="file.frequency" style="font-size:15px;">
                <strong>Frecuencia de la actualización:</strong> {{file.frequency}}
              </p>
              <p v-if="file.position" style="font-size:15px;">
                <strong>Cargo:</strong> {{file.position}}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="files" v-if="canShowRecentFile()">
        <h4>Datos y Recursos</h4>
        <div class="table table-condensed table-striped table-responsive">
          <table class="table open-files">
            <tbody>
            <tr class="file-details" v-for="da_file in file.current_files">
              <td class="icon"><span class=""><i class="fa fa-file fa-4x"></i></span></td>
              <td class="title">
                <!--<strong>{{da_file.title}}</strong>-->
                <span v-if="canShowFileDescription()">{{da_file.description}}</span>
              </td>
              <td class="download">
                <a v-if="canShowDetailsLink(da_file.external_link)" :href="da_file.external_link" target="_blank" class="button pink-dark rounded icon-left small">
                  <span><i class="fa fa-external-link"></i>Ver Datos</span>
                </a>
                <br v-if="canShowDetailsLink(da_file.external_link)">
                <br v-if="canShowDetailsLink(da_file.external_link)">
                <a :href="da_file.url" v-if="da_file.url" class="button pink-dark rounded icon-left small" target="_blank">
                  <span><i class="fa fa-download"></i>Descarga</span>
                </a>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="files" v-if="canShowHistoryFile()">
        <h4>Archivos Históricos</h4>
        <div class="table table-condensed table-striped table-responsive">
          <table class="table open-files">
            <tbody>
            <tr class="file-details" v-for="da_file in file.historical_files">
              <td class="icon"><span class=""><i class="fa fa-file fa-4x"></i></span></td>
              <td class="title">
                <!--<strong>{{da_file.title}}</strong>-->
                <span v-if="canShowFileDescription()"><br>{{da_file.description}}</span>
              </td>
              <td class="download">
                <a v-if="canShowDetailsLink(da_file.external_link)" :href="da_file.external_link" target="_blank" class="button pink-dark rounded icon-left small">
                  <span><i class="fa fa-chart"></i>Vista Previa</span>
                </a>
                <br v-if="canShowDetailsLink(da_file.external_link)">
                <br v-if="canShowDetailsLink(da_file.external_link)">
                <a :href="da_file.url" v-if="da_file.url" class="button pink-dark rounded icon-left small" target="_blank">
                  <span><i class="fa fa-download"></i>Descarga</span>
                </a>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import axios from 'axios';

  import Loading from './Loading';

  /* global datos_abiertos */
  export default {
    name: 'SingleFile',
    components: {
      Loading,
    },
    data() {
      return {
        file: {},
        topic: '',
        area: '',
        area_description: '',
        isLoading: false,
      };
    },
    created() {
      this.isLoading = true;
      const slug = this.$route.params.slug;
      const apiUrl = datos_abiertos.api_url;
      const data = {
        slug,
      };
      axios.post(`${apiUrl}/wp-json/datos-abiertos/v1/archivo`, data).then((response) => {
        this.isLoading = false;
        if (response.status === 200) {
          this.file = response.data;
          this.topic = this.file.topics[0].title;
          this.area = this.file.areas[0].title;
          this.area_description = this.file.areas[0].description;
        }
      }).catch((e) => {
        this.error = e;
        console.log(this.error);
      });
    },
    methods: {
      canShowRecentFile() {
        if (this.file.current_files) {
          return this.file.current_files.length;
        }
        return false;
      },
      canShowHistoryFile() {
        if (this.file.historical_files) {
          return this.file.historical_files.length;
        }
        return false;
      },
      canShowFileDescription() {
        if (this.file.description) {
          return this.file.description.length;
        }
        return false;
      },
      canShowDetailsLink(externalLink) {
        if (externalLink) {
          return externalLink.length;
        }
        return false;
      },
    },
  };
</script>

<style>
  .dato-abierto {
    font-size: 16px;
  }

  .dato-abierto strong {
    font-weight: 700;
  }

  .dato-abierto .files {
    margin-top: 40px;
  }

  .dato-abierto .area-topic {
    margin-top: 20px;
  }

  .table-striped tbody tr:nth-of-type(odd) {
    background-color: white !important;
  }

  .file-details td.icon {
    width: 10%;
  }

  .file-details td.title {
    width: 70%;
  }

  .file-details td.download {
    width: 20%;
  }

  .file-details .button.pink-dark {
    background-color: #F51E70;
    border-color: #e31865;
    color: white;
    text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.2);
    padding: 10px 15px;
    text-transform: uppercase;
    font-size: 11px;
    font-weight: 700;
    text-decoration: underline;
  }

  .file-details .button.pink-dark span i {
    margin-right: 5px;
  }
</style>



// WEBPACK FOOTER //
// SingleFile.vue?67725c00